import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'help_center-self_serve_article_link-click';

/**
 * Link click event from self-serve article links
 */
export function trackHelpCenterSelfServeArticleLinkClick(
  article_id: string,
  article_name2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { article_id, article_name2 },
  });
}
